(() => {
  const apply = () => {
    const ended = document.documentElement.dataset.agroOzEnded === 'true';
    if (!ended) return;
    document.querySelectorAll('[data-agro-oz-active]').forEach(el => { el.hidden = true; });
    document.querySelectorAll('[data-agro-oz-expired]').forEach(el => { el.hidden = false; });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
